import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, AlertProps } from 'antd';
import styled from 'styled-components';
import { Palette, themeConfig, useThemeContext } from '@/shared/theme';

export const Banner = (props: AlertProps) => {
  const { theme } = useThemeContext();

  return (
    <BannerWrapper
      banner
      icon={<InfoCircleOutlined />}
      colors={themeConfig[theme].colors}
      {...props}
    />
  );
};

const BannerWrapper = styled(Alert)<{ colors: Palette }>`
  font-size: 12px;
  padding: 3px 12px;
  color: #fff;
  justify-content: space-between;
  position: sticky;
  &.ant-alert-info {
    background-color: ${({ colors }) => colors.primary};
  }
  &.ant-alert-error {
    background-color: ${({ colors }) => colors.error};
  }
  &.ant-alert-warning {
    background-color: ${({ colors }) => colors.warning};
  }
  .ant-alert-close-icon .anticon-close {
    color: #fff;
  }
  .ant-alert-icon {
    color: #fff;
    margin-left: auto;
  }
  .ant-alert-content {
    flex: none;
    margin-right: auto;
  }
`;
